import type { AxiosInstance } from 'axios';
import { apiClient } from '../client/client';
import type { ServiceResultT } from '../types/common/ServiceResultT';
import type {
  SecurityAccessLogPaginatedList,
  SecurityAccessLogQueryFilter,
} from '../types/securityLog';

export class SecurityLogService {
  private static readonly BASE = '/api/admin/security-logs';
  private static readonly MIN_PAGE_SIZE = 1;
  private static readonly MAX_PAGE_SIZE = 200;

  constructor(private readonly client: AxiosInstance = apiClient) {}

  async query(
    filter: SecurityAccessLogQueryFilter,
  ): Promise<ServiceResultT<SecurityAccessLogPaginatedList>> {
    const params = SecurityLogService.buildParams(filter);

    try {
      const { data } = await this.client.get<ServiceResultT<SecurityAccessLogPaginatedList>>(
        SecurityLogService.BASE,
        { params },
      );
      return data;
    } catch (err: unknown) {
      const res =
        err && typeof err === 'object' && 'response' in err
          ? (err as { response?: { status?: number; data?: unknown } }).response
          : undefined;

      if (res?.status === 403) {
        return {
          isSuccess: false,
          statusCode: 403,
          message: 'Bu sayfayı görüntüleme yetkiniz yok.',
          data: null,
        };
      }

      throw err;
    }
  }

  private static buildParams(filter: SecurityAccessLogQueryFilter): Record<string, string | number> {
    const params: Record<string, string | number> = {};
    if (filter.ipAddress?.trim()) params.ipAddress = filter.ipAddress.trim();
    if (filter.userId?.trim()) params.userId = filter.userId.trim();
    if (filter.fromUtc) params.fromUtc = filter.fromUtc;
    if (filter.toUtc) params.toUtc = filter.toUtc;

    const pageNumber = filter.pageNumber ?? 1;
    const pageSize = Math.min(
      Math.max(filter.pageSize ?? 50, SecurityLogService.MIN_PAGE_SIZE),
      SecurityLogService.MAX_PAGE_SIZE,
    );
    params.pageNumber = pageNumber;
    params.pageSize = pageSize;
    return params;
  }
}

export const securityLogService = new SecurityLogService();
